const dataSourceTypes = Object.freeze({
  googleAnalytics: "Google Analytics",
  googleAds: "Google Ads",
  googleAdwords: "Google Adwords",
  googleSearchConsole: "Google Search Console",
  facebook: "Facebook",
  slack: "Slack",
  amazon: "Amazon Ads",
  pinterest: "Pinterest Ads",
  shopify: "Shopify",
  googleAnalytics4: "Google Analytics 4",
  facebookInstagramAds: "Facebook & Instagram Ads"
});

const dataSourceTypeKeys = Object.freeze({
  googleAnalytics: "googleAnalytics",
  googleAds: "googleAds",
  googleAdwords: "googleAdwords",
  googleSearchConsole: "googleSearchConsole",
  facebook: "facebook",
  slack: "slack",
  amazon: "amazon",
  pinterest: "pinterest",
  shopify: "shopify",
  googleAnalytics4: "googleAnalytics4",
  facebookInstagramAds: "facebookInstagramAds"
});

const dataSourceTypeIcons = Object.freeze({
  "Google Analytics": "google-analytics.svg",
  "Google Search Console": "google-search.svg",
  "Google Ads": "google-adwords.svg",
  "Google Adwords": "google-adwords.svg",
  "Facebook": "facebook.svg",
  "Slack": "slack.svg",
  "Amazon Ads": "amazon-ads.svg",
  "Pinterest Ads": "pinterest.svg",
  "Shopify": "shopify.svg",
  "Google Analytics 4": "google-analytics.svg"
});

const dataSourceTypesDropdownItems = Object.freeze([
  {
    id: "Google Analytics",
    title: "Google Analytics",
    image: "google-analytics.svg"
  },
  {
    id: "Google Analytics 4",
    title: "Google Analytics 4",
    image: "google-analytics.svg"
  },
  {
    id: "Google Ads",
    title: "Google Ads",
    image: "google-adwords.svg"
  },
  {
    id: "Google Search Console",
    title: "Google Search Console",
    image: "google-search.svg"
  },
  {
    id: "Facebook",
    title: "Facebook",
    image: "facebook.svg"
  }
]);

const priorities = Object.freeze({
  urgent: "Urgent",
  report: "Report",
  warning: "Warning",
  opportunity: "Opportunity",
  perfect: "Perfect"
});

const priorityKeys = Object.freeze({
  urgent: "urgent",
  report: "report",
  warning: "warning",
  opportunity: "opportunity",
  perfect: "perfect"
});

const clientRoles = Object.freeze({
  owner: "owner",
  admin: "admin",
  viewer: "viewer"
});

const cookieNames = Object.freeze({
  "heyboosterDontShowMissingDataPopup": "heyboosterDontShowMissingDataPopup"
});

const onboardingPages = Object.freeze([
  "customize",
  "insight-categories",
  "connect",
  "onboardingPaymentSubscription"
]);


const authenticationURLList = Object.freeze({
  [dataSourceTypeKeys.googleAnalytics]: "authentication/google/analytics/oauth/",
  [dataSourceTypeKeys.googleAnalytics4]: "authentication/google/analytics/oauth/",
  [dataSourceTypeKeys.googleAds]: "authentication/google/adwords/oauth/",
  [dataSourceTypeKeys.googleSearchConsole]: "authentication/google/search-console/oauth/",
  [dataSourceTypeKeys.facebook]: "authentication/facebook/oauth/",
  [dataSourceTypeKeys.slack]: "authentication/slack/oauth/"
});

const localStorageKeys = Object.freeze({
  "heybooster": "heybooster",
  "activeClientBookmarkID": "activeClientBookmarkID",
  "activeClientID": "activeClientID",
  "jwt": "jwt",
  "jwtExpirationTime": "jwtExpirationTime",
  "jwtSessionKey": "jwtSessionKey",
  "user": "user",
  "userRole": "userRole",
  "lastVisitedPage": "lastVisitedPage",
  "runningPackages": "runningPackages",
  "logout": "logout",
  "stepsConnectStatus": "stepsConnectStatus",
  "lastCreatedStepsData": "lastCreatedStepsData",
  "newSession": "newSession",
  "redirectURL": "redirectURL",
  "connectedIntegrations": "connectedIntegrations",
  "packetQueueToRun": "packetQueueToRun",
  "onboardingSelectedPackages": "onboardingSelectedPackages",
  "selectedPlan": "selectedPlan",
  "business": "business",
  "selectedKPIs": "selectedKPIs",
  "onboardingSelectedRequiredSourceTypes": "onboardingSelectedRequiredSourceTypes",
  "activeStepComponentInformation": "activeStepComponentInformation"
});

const amplitudeEventNames = Object.freeze({
  "sessionStart": "session_start",
  "viewPackageResults": "view_package_results",
  "shareInsight": "share_insight",
  "moveInprogress": "move_inprogress",
  "showOpportunities": "show_opportunities",
  "createClient": "add_client",
  "createKPI": "set_kpi",
  "updateKPI": "update_kpi",
  "explorePackage": "explore_package",
  "insightConnect": "insight_connect",
  "createDataSource": "create_collection",
  "filterByCategory": "filter_bycategory",
  "premiumPackageClick": "premium_package_click",
  "notifyMeInsightClick": "notify_me_insight_click",
  "requestInsightInsightClick": "request_insight_insight_click",
  "seeRelatedInsight": "see_related_insight",
  "quickFilter": "quick_filter",
  "filter": "filter",
  "connectApp": "connect_app",
  "connectClickUpComing": "connect_click_upcoming",
  "notifyMePackageClick": "notify_me_package_click",
  "paymentTried": "payment_tried",
  "trialStarted": "trial_started",
  "upgradeYourPlan": "upgrade_your_plan",
  "seePlansPricing": "see_plans_pricing",
  "addMember": "add_member",
  "notifyMeInsightDone": "notify_me_insight_done",
  "notifyMePackageDone": "notify_me_package_done",
  "createNotification": "set_notification",
  "requestInsightPackageDone": "request_insight_package_done",
  "requestInsightInsightDone": "request_insight_insight_done",
  "upgradeClick": "upgrade_click",
  "viewClient": "view_client",
  "bookmarkInsight": "bookmark_insight",
  "viewInsightDetail": "view_insight_detail",
  "foundError": "found_error",
  "onboardingInterest": "onboarding_interest",
  "onboardingKPI": "onboarding_kpi",
  "requestExpert": "request_expert",
  "cancelSubscription": "cancel_subscription",
  "bookADemo": "book_a_demo",
});

const currencySymbols = Object.freeze({
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "₿",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  COU: "COU",
  CRC: "₡",
  CUC: "$",
  CUP: "₱",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "دج",
  EEK: "kr",
  EGP: "£",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "Ξ",
  EUR: "€",
  FJD: "$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHC: "₵",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "£",
  LKR: "₨",
  LRD: "$",
  LSL: "M",
  LTC: "Ł",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "₨",
  NZD: "$",
  OMR: "﷼",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "Gs",
  QAR: "﷼",
  RMB: "￥",
  RON: "lei",
  RSD: "Дин.",
  RUB: "₽",
  RWF: "R₣",
  SAR: "﷼",
  SBD: "$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRL: "₤",
  TRY: "₺",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "лв",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "₫",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "Ƀ",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$"
});


export {
  dataSourceTypes,
  dataSourceTypesDropdownItems,
  dataSourceTypeIcons,
  priorities,
  priorityKeys,
  clientRoles,
  cookieNames,
  onboardingPages,
  dataSourceTypeKeys,
  authenticationURLList,
  localStorageKeys,
  amplitudeEventNames,
  currencySymbols
};






// WEBPACK FOOTER //
// ./src/enums/common/index.js